// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/settings/v1/admin_settings.proto" (package "c1.api.settings.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Duration } from "../../../../google/protobuf/duration";
import { Status } from "../../../../google/rpc/status";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.settings.v1.GetAWSExternalIDRequest
 */
export interface GetAWSExternalIDRequest {
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetAWSExternalIDResponse
 */
export interface GetAWSExternalIDResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.AWSExternalID aws_external_id = 1;
     */
    awsExternalId?: AWSExternalID;
}
/**
 * @generated from protobuf message c1.api.settings.v1.DailyDigestSetting
 */
export interface DailyDigestSetting {
    /**
     * @generated from protobuf field: bool send_digest = 1;
     */
    sendDigest: boolean;
    /**
     * @generated from protobuf field: bool digest_frequency_daily = 2;
     */
    digestFrequencyDaily: boolean;
    /**
     * @generated from protobuf field: bool digest_frequency_tuesdays = 3;
     */
    digestFrequencyTuesdays: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetDailyDigestRequest
 */
export interface GetDailyDigestRequest {
}
/**
 * @generated from protobuf message c1.api.settings.v1.CreateDailyDigestRequest
 */
export interface CreateDailyDigestRequest {
    /**
     * @generated from protobuf field: c1.api.settings.v1.DailyDigestSetting daily_digest_setting = 1;
     */
    dailyDigestSetting?: DailyDigestSetting;
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateDailyDigestRequest
 */
export interface UpdateDailyDigestRequest {
    /**
     * @generated from protobuf field: c1.api.settings.v1.DailyDigestSetting daily_digest_setting = 1;
     */
    dailyDigestSetting?: DailyDigestSetting;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.settings.v1.TestSourceIPRequest
 */
export interface TestSourceIPRequest {
    /**
     * if unset, uses the source IP of the request
     *
     * @generated from protobuf field: string source_ip = 1;
     */
    sourceIp: string;
    /**
     * @generated from protobuf field: repeated string allow_cidr = 2;
     */
    allowCidr: string[];
}
/**
 * @generated from protobuf message c1.api.settings.v1.TestSourceIPResponse
 */
export interface TestSourceIPResponse {
    /**
     * @generated from protobuf field: bool allowed = 1;
     */
    allowed: boolean;
    /**
     * @generated from protobuf field: google.rpc.Status details = 2;
     */
    details?: Status;
    /**
     * @generated from protobuf field: string checked_ip = 3;
     */
    checkedIp: string;
}
/**
 * @generated from protobuf message c1.api.settings.v1.AWSExternalID
 */
export interface AWSExternalID {
    /**
     * @generated from protobuf field: string external_id = 1;
     */
    externalId: string;
}
/**
 * @generated from protobuf message c1.api.settings.v1.CIDRRestriction
 */
export interface CIDRRestriction {
    /**
     * @generated from protobuf field: bool enabled = 1;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: repeated string source_cidr = 2;
     */
    sourceCidr: string[];
}
/**
 * @generated from protobuf message c1.api.settings.v1.SessionSettings
 */
export interface SessionSettings {
    /**
     * @generated from protobuf field: google.protobuf.Duration max_session_length = 1;
     */
    maxSessionLength?: Duration;
    /**
     * @generated from protobuf field: c1.api.settings.v1.CIDRRestriction sso_admin_source = 2;
     */
    ssoAdminSource?: CIDRRestriction;
    /**
     * @generated from protobuf field: c1.api.settings.v1.CIDRRestriction sso_user_source = 3;
     */
    ssoUserSource?: CIDRRestriction;
    /**
     * @generated from protobuf field: c1.api.settings.v1.CIDRRestriction pcc_admin_source = 4;
     */
    pccAdminSource?: CIDRRestriction;
    /**
     * @generated from protobuf field: c1.api.settings.v1.CIDRRestriction pcc_user_source = 5;
     */
    pccUserSource?: CIDRRestriction;
    /**
     * @generated from protobuf field: c1.api.settings.v1.CIDRRestriction connector_source = 6;
     */
    connectorSource?: CIDRRestriction;
    /**
     * IP allowlist for external clients (DCR/MCP)
     *
     * @generated from protobuf field: c1.api.settings.v1.CIDRRestriction external_client_source = 7;
     */
    externalClientSource?: CIDRRestriction;
    /**
     * Enable external client registration (OAuth 2.0 DCR) for MCP clients
     * like Claude Desktop, Cursor, and other AI assistants.
     *
     * @generated from protobuf field: bool external_clients_enabled = 8;
     */
    externalClientsEnabled: boolean;
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetSessionSettingsRequest
 */
export interface GetSessionSettingsRequest {
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetSessionSettingsResponse
 */
export interface GetSessionSettingsResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.SessionSettings session_settings = 1;
     */
    sessionSettings?: SessionSettings;
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateSessionSettingsRequest
 */
export interface UpdateSessionSettingsRequest {
    /**
     * @generated from protobuf field: c1.api.settings.v1.SessionSettings session_settings = 1;
     */
    sessionSettings?: SessionSettings;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateSessionSettingsResponse
 */
export interface UpdateSessionSettingsResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.SessionSettings session_settings = 1;
     */
    sessionSettings?: SessionSettings;
}
/**
 * @generated from protobuf message c1.api.settings.v1.OrgDomain
 */
export interface OrgDomain {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string domain = 2;
     */
    domain: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.settings.v1.ListOrgDomainsRequest
 */
export interface ListOrgDomainsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.settings.v1.ListOrgDomainsResponse
 */
export interface ListOrgDomainsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.settings.v1.OrgDomain list = 1;
     */
    list: OrgDomain[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateOrgDomainRequest
 */
export interface UpdateOrgDomainRequest {
    /**
     * @generated from protobuf field: repeated string new_domains = 1;
     */
    newDomains: string[];
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateOrgDomainResponse
 */
export interface UpdateOrgDomainResponse {
    /**
     * @generated from protobuf field: repeated c1.api.settings.v1.OrgDomain list = 1;
     */
    list: OrgDomain[];
}
/**
 * @generated from protobuf message c1.api.settings.v1.NotificationConfig
 */
export interface NotificationConfig {
    /**
     * @generated from protobuf field: bool disable_email_notifications = 1;
     */
    disableEmailNotifications: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 10;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 11;
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetNotificationConfigRequest
 */
export interface GetNotificationConfigRequest {
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetNotificationConfigResponse
 */
export interface GetNotificationConfigResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.NotificationConfig notification_config = 1;
     */
    notificationConfig?: NotificationConfig;
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateNotificationConfigRequest
 */
export interface UpdateNotificationConfigRequest {
    /**
     * @generated from protobuf field: c1.api.settings.v1.NotificationConfig notification_config = 1;
     */
    notificationConfig?: NotificationConfig;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateNotificationConfigResponse
 */
export interface UpdateNotificationConfigResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.NotificationConfig notification_config = 1;
     */
    notificationConfig?: NotificationConfig;
}
// @generated message type with reflection information, may provide speed optimized methods
class GetAWSExternalIDRequest$Type extends MessageType<GetAWSExternalIDRequest> {
    constructor() {
        super("c1.api.settings.v1.GetAWSExternalIDRequest", [], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "AWS_EXTERNAL_ID" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetAWSExternalIDRequest
 */
export const GetAWSExternalIDRequest = new GetAWSExternalIDRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAWSExternalIDResponse$Type extends MessageType<GetAWSExternalIDResponse> {
    constructor() {
        super("c1.api.settings.v1.GetAWSExternalIDResponse", [
            { no: 1, name: "aws_external_id", kind: "message", T: () => AWSExternalID }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetAWSExternalIDResponse
 */
export const GetAWSExternalIDResponse = new GetAWSExternalIDResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DailyDigestSetting$Type extends MessageType<DailyDigestSetting> {
    constructor() {
        super("c1.api.settings.v1.DailyDigestSetting", [
            { no: 1, name: "send_digest", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "digest_frequency_daily", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "digest_frequency_tuesdays", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.DailyDigestSetting
 */
export const DailyDigestSetting = new DailyDigestSetting$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDailyDigestRequest$Type extends MessageType<GetDailyDigestRequest> {
    constructor() {
        super("c1.api.settings.v1.GetDailyDigestRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetDailyDigestRequest
 */
export const GetDailyDigestRequest = new GetDailyDigestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDailyDigestRequest$Type extends MessageType<CreateDailyDigestRequest> {
    constructor() {
        super("c1.api.settings.v1.CreateDailyDigestRequest", [
            { no: 1, name: "daily_digest_setting", kind: "message", T: () => DailyDigestSetting }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.CreateDailyDigestRequest
 */
export const CreateDailyDigestRequest = new CreateDailyDigestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDailyDigestRequest$Type extends MessageType<UpdateDailyDigestRequest> {
    constructor() {
        super("c1.api.settings.v1.UpdateDailyDigestRequest", [
            { no: 1, name: "daily_digest_setting", kind: "message", T: () => DailyDigestSetting, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateDailyDigestRequest
 */
export const UpdateDailyDigestRequest = new UpdateDailyDigestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TestSourceIPRequest$Type extends MessageType<TestSourceIPRequest> {
    constructor() {
        super("c1.api.settings.v1.TestSourceIPRequest", [
            { no: 1, name: "source_ip", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^([0-9]{1,3}\\.){3}[0-9]{1,3}(\\/([0-9]|[1-2][0-9]|3[0-2]))?$", ignoreEmpty: true } } } },
            { no: 2, name: "allow_cidr", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^([0-9]{1,3}\\.){3}[0-9]{1,3}(\\/([0-9]|[1-2][0-9]|3[0-2]))?$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.TestSourceIPRequest
 */
export const TestSourceIPRequest = new TestSourceIPRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TestSourceIPResponse$Type extends MessageType<TestSourceIPResponse> {
    constructor() {
        super("c1.api.settings.v1.TestSourceIPResponse", [
            { no: 1, name: "allowed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "details", kind: "message", T: () => Status },
            { no: 3, name: "checked_ip", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.TestSourceIPResponse
 */
export const TestSourceIPResponse = new TestSourceIPResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AWSExternalID$Type extends MessageType<AWSExternalID> {
    constructor() {
        super("c1.api.settings.v1.AWSExternalID", [
            { no: 1, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "AWS_EXTERNAL_ID" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.AWSExternalID
 */
export const AWSExternalID = new AWSExternalID$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CIDRRestriction$Type extends MessageType<CIDRRestriction> {
    constructor() {
        super("c1.api.settings.v1.CIDRRestriction", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "source_cidr", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^([0-9]{1,3}\\.){3}[0-9]{1,3}(\\/([0-9]|[1-2][0-9]|3[0-2]))?$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.CIDRRestriction
 */
export const CIDRRestriction = new CIDRRestriction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionSettings$Type extends MessageType<SessionSettings> {
    constructor() {
        super("c1.api.settings.v1.SessionSettings", [
            { no: 1, name: "max_session_length", kind: "message", T: () => Duration, options: { "validate.rules": { duration: { in: [{ seconds: "2700" }, { seconds: "3600" }, { seconds: "7200" }, { seconds: "14400" }, { seconds: "28800" }, { seconds: "57600" }, { seconds: "72000" }] } } } },
            { no: 2, name: "sso_admin_source", kind: "message", T: () => CIDRRestriction },
            { no: 3, name: "sso_user_source", kind: "message", T: () => CIDRRestriction },
            { no: 4, name: "pcc_admin_source", kind: "message", T: () => CIDRRestriction },
            { no: 5, name: "pcc_user_source", kind: "message", T: () => CIDRRestriction },
            { no: 6, name: "connector_source", kind: "message", T: () => CIDRRestriction },
            { no: 7, name: "external_client_source", kind: "message", T: () => CIDRRestriction },
            { no: 8, name: "external_clients_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SessionSettings
 */
export const SessionSettings = new SessionSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSessionSettingsRequest$Type extends MessageType<GetSessionSettingsRequest> {
    constructor() {
        super("c1.api.settings.v1.GetSessionSettingsRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetSessionSettingsRequest
 */
export const GetSessionSettingsRequest = new GetSessionSettingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSessionSettingsResponse$Type extends MessageType<GetSessionSettingsResponse> {
    constructor() {
        super("c1.api.settings.v1.GetSessionSettingsResponse", [
            { no: 1, name: "session_settings", kind: "message", T: () => SessionSettings }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetSessionSettingsResponse
 */
export const GetSessionSettingsResponse = new GetSessionSettingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSessionSettingsRequest$Type extends MessageType<UpdateSessionSettingsRequest> {
    constructor() {
        super("c1.api.settings.v1.UpdateSessionSettingsRequest", [
            { no: 1, name: "session_settings", kind: "message", T: () => SessionSettings },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateSessionSettingsRequest
 */
export const UpdateSessionSettingsRequest = new UpdateSessionSettingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSessionSettingsResponse$Type extends MessageType<UpdateSessionSettingsResponse> {
    constructor() {
        super("c1.api.settings.v1.UpdateSessionSettingsResponse", [
            { no: 1, name: "session_settings", kind: "message", T: () => SessionSettings }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateSessionSettingsResponse
 */
export const UpdateSessionSettingsResponse = new UpdateSessionSettingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrgDomain$Type extends MessageType<OrgDomain> {
    constructor() {
        super("c1.api.settings.v1.OrgDomain", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.OrgDomain
 */
export const OrgDomain = new OrgDomain$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOrgDomainsRequest$Type extends MessageType<ListOrgDomainsRequest> {
    constructor() {
        super("c1.api.settings.v1.ListOrgDomainsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.ListOrgDomainsRequest
 */
export const ListOrgDomainsRequest = new ListOrgDomainsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOrgDomainsResponse$Type extends MessageType<ListOrgDomainsResponse> {
    constructor() {
        super("c1.api.settings.v1.ListOrgDomainsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrgDomain },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.ListOrgDomainsResponse
 */
export const ListOrgDomainsResponse = new ListOrgDomainsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrgDomainRequest$Type extends MessageType<UpdateOrgDomainRequest> {
    constructor() {
        super("c1.api.settings.v1.UpdateOrgDomainRequest", [
            { no: 1, name: "new_domains", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateOrgDomainRequest
 */
export const UpdateOrgDomainRequest = new UpdateOrgDomainRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrgDomainResponse$Type extends MessageType<UpdateOrgDomainResponse> {
    constructor() {
        super("c1.api.settings.v1.UpdateOrgDomainResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrgDomain }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateOrgDomainResponse
 */
export const UpdateOrgDomainResponse = new UpdateOrgDomainResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationConfig$Type extends MessageType<NotificationConfig> {
    constructor() {
        super("c1.api.settings.v1.NotificationConfig", [
            { no: 1, name: "disable_email_notifications", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.NotificationConfig
 */
export const NotificationConfig = new NotificationConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetNotificationConfigRequest$Type extends MessageType<GetNotificationConfigRequest> {
    constructor() {
        super("c1.api.settings.v1.GetNotificationConfigRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetNotificationConfigRequest
 */
export const GetNotificationConfigRequest = new GetNotificationConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetNotificationConfigResponse$Type extends MessageType<GetNotificationConfigResponse> {
    constructor() {
        super("c1.api.settings.v1.GetNotificationConfigResponse", [
            { no: 1, name: "notification_config", kind: "message", T: () => NotificationConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetNotificationConfigResponse
 */
export const GetNotificationConfigResponse = new GetNotificationConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateNotificationConfigRequest$Type extends MessageType<UpdateNotificationConfigRequest> {
    constructor() {
        super("c1.api.settings.v1.UpdateNotificationConfigRequest", [
            { no: 1, name: "notification_config", kind: "message", T: () => NotificationConfig, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateNotificationConfigRequest
 */
export const UpdateNotificationConfigRequest = new UpdateNotificationConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateNotificationConfigResponse$Type extends MessageType<UpdateNotificationConfigResponse> {
    constructor() {
        super("c1.api.settings.v1.UpdateNotificationConfigResponse", [
            { no: 1, name: "notification_config", kind: "message", T: () => NotificationConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateNotificationConfigResponse
 */
export const UpdateNotificationConfigResponse = new UpdateNotificationConfigResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.settings.v1.AWSExternalIDSettings
 */
export const AWSExternalIDSettings = new ServiceType("c1.api.settings.v1.AWSExternalIDSettings", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/settings/aws-external-id", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "AWS_EXTERNAL_ID" }], group: "AWS External ID Settings" }] } }, I: GetAWSExternalIDRequest, O: GetAWSExternalIDResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.settings.v1.DailyDigestSettings
 */
export const DailyDigestSettings = new ServiceType("c1.api.settings.v1.DailyDigestSettings", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: GetDailyDigestRequest, O: DailyDigestSetting },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: UpdateDailyDigestRequest, O: DailyDigestSetting }
]);
/**
 * @generated ServiceType for protobuf service c1.api.settings.v1.SessionSettingsService
 */
export const SessionSettingsService = new ServiceType("c1.api.settings.v1.SessionSettingsService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/settings/session", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "SessionSettings", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Session Settings" }] } }, I: GetSessionSettingsRequest, O: GetSessionSettingsResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/settings/session", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "SessionSettings" }], group: "Session Settings" }] } }, I: UpdateSessionSettingsRequest, O: UpdateSessionSettingsResponse },
    { name: "TestSourceIP", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/settings/session/test-source-ip", group: "Session Settings" }] } }, I: TestSourceIPRequest, O: TestSourceIPResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.settings.v1.OrgDomainService
 */
export const OrgDomainService = new ServiceType("c1.api.settings.v1.OrgDomainService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/settings/domains", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "OrgDomains", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "Org Domain", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: ListOrgDomainsRequest, O: ListOrgDomainsResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "PUT", route: "/api/v1/settings/domains", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "OrgDomains" }], group: "Org Domain" }] } }, I: UpdateOrgDomainRequest, O: UpdateOrgDomainResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.settings.v1.NotificationConfigService
 */
export const NotificationConfigService = new ServiceType("c1.api.settings.v1.NotificationConfigService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: GetNotificationConfigRequest, O: GetNotificationConfigResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: UpdateNotificationConfigRequest, O: UpdateNotificationConfigResponse }
]);
